import store from '@/store'
import { setStore } from '@/utils/setStore'

export default (vm) => {
  if (store.state.userInfo?.unionid) return true
  // setStore('longDialogShow', true)
}
